import Link from 'next/link'
import React, { useState } from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'
import { DropdownButton, DropdownPopover } from '../DropdownLink'
import { HeaderLink } from '../HeaderLink'
import Stack from '@careguide/stack'

const TopCitiesDropdown = ({ items = [] }: { items: TODO[] }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Container
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onClick={() => setIsOpen(false)}
    >
      <DropdownButton isExpanded={isOpen} aria-hidden>
        Top Cities
      </DropdownButton>
      {isOpen && (
        <DropdownPopover>
          {items.map((item: TODO, index) => (
            <Stack key={index}>
              <Heading>{item.title}</Heading>
              {item.navigationItems.map((childItem: TODO, index: number) => (
                <Link key={index} href={childItem.link} passHref={true}>
                  <HeaderLink>{childItem.title}</HeaderLink>
                </Link>
              ))}
            </Stack>
          ))}
        </DropdownPopover>
      )}
    </Container>
  )
}

export default TopCitiesDropdown

const Container = styled.div`
  align-self: center;
  position: relative;
`

const Heading = styled.h4`
  margin-top: 12px;
  margin-bottom: 0;
  padding: 0 12px;

  ${css({ color: 'gray.6', fontFamily: 'base' })}
`
